import React, { useState, useContext } from "react";
import { isEmpty, callApi, blockEmoji } from "bodycodi/cmap/app/js/common";
import { StateContext, DispatchContext } from "bodycodi/cmap/app/components/common/context";
import CustomDialog from "bodycodi/cmap/app/components/common/customDialog";
import PopupHeader from "bodycodi/cmap/app/components/common/popupHeader";

function ChangeNamePopWrap(prop: any) {
  const { state } = useContext(StateContext);
  const { dispatch } = useContext(DispatchContext);

  const handleClose = () => {
    dispatch({ type: "POP_UP_OPEN", id: "CHANGE_NAME_POP", open: { changeNamePop: false } });
  };

  return (
    <CustomDialog open={state.changeNamePop} onClose={handleClose}>
      <PopupHeader title="이름 수정" onClickBack={handleClose} />
      <div className="popup-body">
        {state.changeNamePop && <ChangeName handleClose={handleClose} {...prop} />}
      </div>
    </CustomDialog>
  );
}

type ChangeNameProps = {
  handleClose: Function;
  update: Function;
  updateP: Function;
  d: any;
};

function ChangeName({ handleClose, update, updateP, d }: ChangeNameProps) {
  const { dispatch } = useContext(DispatchContext);
  const [name, setName] = useState<string>(d.name || "");

  const openAlert = (msgCtnt: string, func: any) => {
    if (isEmpty(func)) {
      func = () => {};
    }
    dispatch({
      type: "ALERT_SETTING",
      data: {
        header: "이름 수정",
        cancleYn: false,
        redYn: false,
        body: msgCtnt,
        cancelAlert: () => {},
        closeAlert: func,
        alert: true,
      },
    });
  };

  const handleChangeName = () => {
    if (name.length < 1) return null;
    const data = {
      name,
      seqMobileMembers: d.seqMobileMembers,
    };
    callApi("/cmap5040/execNameUpd", data, "POST").then((res) => {
      const msgVO = res.MsgVO;
      if (msgVO.msgCd !== "SCRA6050-00") {
        openAlert(msgVO.msgCtnt, handleClose);
      } else {
        update();
        updateP();
        handleClose();
      }
    });
  };

  return (
    <React.Fragment>
      <div className="change-name-pop">
        <div className="change-info-pop change-password-input-wrap">
          <Input
            title="이름"
            type="text"
            name="name"
            placeholder=""
            value={name}
            onChange={setName}
          />
        </div>
        <div className="device-ctrfcation-footer change-password">
          <div className={"btn" + (name.length > 0 ? " active1" : "")} onClick={handleChangeName}>
            <div>완료</div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

type InputProps = {
  type: string;
  name?: string;
  placeholder: string;
  title: string;
  value?: string;
  onChange: Function;
};

export const Input = ({ name, placeholder, title, value, onChange }: InputProps) => {
  const handleOnInput = (e: any) => {
    const updatedValue = blockEmoji(e.target.value).trim().substring(0, 20);
    onChange(updatedValue);
  };

  return (
    <div className={"cmap1010-input"}>
      <div className="title">{title}</div>
      <div className={"input-wrap"}>
        <div className="input">
          <input
            type={"text"}
            name={name}
            placeholder={placeholder}
            value={value}
            onInput={handleOnInput}
            maxLength={20}
          />
        </div>
      </div>
      <div className="text-len">
        <span>
          <span>{value?.length}</span>/20
        </span>
      </div>
    </div>
  );
};

export default ChangeNamePopWrap;
